module.exports = {};



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_iterators.js
// module id = 528
// module chunks = 1